import {
  ADD_SIMPLE_PRODUCT_TO_CART,
  ADD_BUNDLE_PRODUCT_TO_CART,
  ADD_CONFIGURABLE_PRODUCT_TO_CART,
  UPDATE_CART,
  REMOVE_FROM_CART,
  GUEST_VIEW_CART,
  GUEST_RESET_CART,
  ADD_COUPON_CODE,
  REMOVE_COUPON_CODE,
  GET_SHIPPING_BILLING,
  GUEST_CART_ITEMS,
  IS_MULTICART,
} from "Redux/actionTypes/index";

import { updateCartExpiry, cartUpdateEvent } from "utils/helperServices";
import ajaxServices from "utils/ajaxServices";

import {
  guestAddSimpleProductToCart,
  guestViewCart,
  guestAddConfigurableProductToCart,
  updateCartItems,
  removeCartItems,
  guestAddBundleProduct,
  AddCouponCode,
  removeCouponCode,
  shippingAndBillingAddress,
} from "../../config/queries";


export const deleteItemsFromCheckout =
  (cartId, cartItemId) => async (dispatch) => {
    const deletedItems = await ajaxServices.fetchGraphQLPOSTRequest(
      removeCartItems,
      {
        cart_id: cartId,
        cart_item_id: cartItemId,
      }
    );

    let cartResult = await ajaxServices.fetchGraphQLPOSTRequest(guestViewCart, {
      cart_id: cartId,
    });
    if (
      cartResult &&
      cartResult.errors &&
      cartResult.data &&
      cartResult.data.cart
    ) {
      deletedItems.removeItemFromCart = cartResult.data;
      cartResult = cartResult.data;
    } else {
      deletedItems.removeItemFromCart = cartResult;
    }

    updateCartExpiry();

    dispatch({
      type: GUEST_VIEW_CART,
      payload: cartResult
    });

    if (deletedItems) {
      cartUpdateEvent();
    }
    return deletedItems;
  };

export const showGuestCart = (cartId) => async (dispatch) => {
  let cartResult = await ajaxServices.fetchGraphQLPOSTRequest(
    guestViewCart,
    {
      cart_id: cartId,
    }
  );

  if (cartResult && cartResult?.errors && cartResult?.data?.cart) {
    cartResult = cartResult.data;
  }

  dispatch({
    type: GUEST_VIEW_CART,
    payload: cartResult
  });

  cartUpdateEvent();

  return cartResult;
};

export const resetGuestCart = () => (dispatch) => {
  dispatch({
    type: GUEST_RESET_CART,
  });
};

export const getShippingAndBilling = (cartId) => async (dispatch) => {
  let cartResult = await ajaxServices.fetchGraphQLPOSTRequest(
    shippingAndBillingAddress,
    {
      cart_id: cartId,
    }
  );
  if (
    cartResult &&
    cartResult.errors &&
    cartResult.data &&
    cartResult.data.cart
  ) {
    cartResult = cartResult.data;
  }
  dispatch({ type: GET_SHIPPING_BILLING, payload: cartResult });
  return cartResult;
};

export const addSimpleProductToGuestCart =
  (cartId, cartItems) => async (dispatch) => {
    const addSimpleProductData = await ajaxServices.fetchGraphQLPOSTRequest(
      guestAddSimpleProductToCart,
      {
        cart_id: cartId,
        cart_items: cartItems,
      }
    );

    if (addSimpleProductData?.status === 200) {
      const cartResult = await ajaxServices.fetchGraphQLPOSTRequest(
        guestViewCart,
        {
          cart_id: cartId,
        }
      );

      if (
        cartResult &&
        cartResult.errors &&
        cartResult.data &&
        cartResult.data.cart
      ) {
        addSimpleProductData.addSimpleProductsToCart = cartResult.data;
      } else {
        addSimpleProductData.addSimpleProductsToCart = cartResult;
      }
      updateCartExpiry();
      dispatch({
        type: ADD_SIMPLE_PRODUCT_TO_CART,
        payload: addSimpleProductData,
      });
      if (addSimpleProductData) {
        cartUpdateEvent();
      }
      return addSimpleProductData;
    } else {
      return addSimpleProductData;
    }
  };

export const addBundleProductToGuestCart =
  (cartId, cartItems) => async (dispatch) => {
    const addBundleProductData = await ajaxServices.fetchGraphQLPOSTRequest(
      guestAddBundleProduct,
      {
        cart_id: cartId,
        cart_items: cartItems,
      }
    );

    if (addBundleProductData?.status === 200) {
      const cartResult = await ajaxServices.fetchGraphQLPOSTRequest(
        guestViewCart,
        {
          cart_id: cartId,
        }
      );
      if (
        cartResult &&
        cartResult.errors &&
        cartResult.data &&
        cartResult.data.cart
      ) {
        addBundleProductData.addBundleProductsToCart = cartResult.data;
      } else {
        addBundleProductData.addBundleProductsToCart = cartResult;
      }
      updateCartExpiry();
      dispatch({
        type: ADD_BUNDLE_PRODUCT_TO_CART,
        payload: addBundleProductData,
      });
      if (addBundleProductData) {
        cartUpdateEvent();
      }
      return addBundleProductData;
    } else {
      return addBundleProductData;
    }
  };

export const addConfigurableToGuestCart =
  (cartId, cartItems) => async (dispatch) => {
    const addConfigurableProductData =
      await ajaxServices.fetchGraphQLPOSTRequest(
        guestAddConfigurableProductToCart,
        {
          cart_id: cartId,
          cart_items: cartItems,
        }
      );

    if (addConfigurableProductData?.status === 200) {
      const cartResult = await ajaxServices.fetchGraphQLPOSTRequest(
        guestViewCart,
        {
          cart_id: cartId,
        }
      );
      if (
        cartResult &&
        cartResult.errors &&
        cartResult.data &&
        cartResult.data.cart
      ) {
        addConfigurableProductData.addConfigurableProductsToCart =
          cartResult.data;
      } else {
        addConfigurableProductData.addConfigurableProductsToCart = cartResult;
      }
      updateCartExpiry();
      dispatch({
        type: ADD_CONFIGURABLE_PRODUCT_TO_CART,
        payload: addConfigurableProductData,
      });
      if (addConfigurableProductData) {
        cartUpdateEvent();
      }
      return addConfigurableProductData;
    } else {
      return addConfigurableProductData;
    }
  };

export const deleteItemsFromCart = (cartId, cartItemId) => async (dispatch) => {
  const deletedItems = await ajaxServices.fetchGraphQLPOSTRequest(
    removeCartItems,
    {
      cart_id: cartId,
      cart_item_id: cartItemId,
    }
  );

  if (deletedItems.removeItemFromCart) {
    const cartResult = await ajaxServices.fetchGraphQLPOSTRequest(
      guestViewCart,
      {
        cart_id: cartId,
      }
    );

    if (
      cartResult &&
      cartResult.errors &&
      cartResult.data &&
      cartResult.data.cart
    ) {
      deletedItems.removeItemFromCart = cartResult.data;
    } else {
      deletedItems.removeItemFromCart = cartResult;
    }
    updateCartExpiry();
    dispatch({
      type: REMOVE_FROM_CART,
      payload: deletedItems,
    });

    cartUpdateEvent();
  }

  return deletedItems;
};

export const updateItemsofCart =
  (cartId, cartItemId, quantity, configureAttributes, customizable_options) =>
  async (dispatch) => {
    const attributes = configureAttributes ? configureAttributes : [];
    const updatedItems = await ajaxServices.fetchGraphQLPOSTRequest(
      updateCartItems,
      {
        cart_id: cartId,
        cart_item_id: cartItemId,
        quantity: quantity,
        attributes: attributes,
        customizable_options: customizable_options,
      }
    );
    const cartResult = await ajaxServices.fetchGraphQLPOSTRequest(
      guestViewCart,
      {
        cart_id: cartId,
      }
    );
    if (
      cartResult &&
      cartResult.errors &&
      cartResult.data &&
      cartResult.data.cart
    ) {
      updatedItems.updateCartItems = cartResult.data;
    } else {
      updatedItems.updateCartItems = cartResult;
    }
    updateCartExpiry();
    dispatch({
      type: UPDATE_CART,
      payload: updatedItems,
    });
    if (updatedItems) {
      cartUpdateEvent();
    }

    dispatch({
      type: GUEST_VIEW_CART,
      payload: cartResult
    });

    return updatedItems;
  };

export const addCouponToCart = (cartId, couponCode) => async (dispatch) => {
  const appliedCoupon = await ajaxServices.fetchGraphQLPOSTRequest(
    AddCouponCode,
    {
      cart_id: cartId,
      coupon_code: couponCode,
    }
  );
  const cartResult = await ajaxServices.fetchGraphQLPOSTRequest(guestViewCart, {
    cart_id: cartId,
  });
  const combined = { ...appliedCoupon, applyCouponToCart: cartResult };
  updateCartExpiry();
  dispatch({
    type: ADD_COUPON_CODE,
    payload: combined,
  });
  return appliedCoupon;
};

export const removeCouponFromCart = (cartId) => async (dispatch) => {
  const removedCoupon = await ajaxServices.fetchGraphQLPOSTRequest(
    removeCouponCode,
    {
      cart_id: cartId,
    }
  );
  const cartResult = await ajaxServices.fetchGraphQLPOSTRequest(guestViewCart, {
    cart_id: cartId,
  });
  removedCoupon.removeCouponFromCart = cartResult;
  updateCartExpiry();
  dispatch({
    type: REMOVE_COUPON_CODE,
    payload: removedCoupon,
  });
  return removedCoupon;
};

export const addGuestCartProducts =
  (products, totalItems, coupon) => (dispatch) => {
    dispatch({
      type: GUEST_CART_ITEMS,
      payload: { products, totalItems, coupon },
    });
  };

export const setCartMulti = (isMulti) => (dispatch) => {
  dispatch({
    type: IS_MULTICART,
    payload: isMulti,
  });
};
